export default __webpack_public_path__ + "static/media/shoes3.00f78359.png";